<template>
  <div>
    <div class="row gutter-sm">
      <div class="col-6 q-pa-md full-height">
        <p class="card-title">Dashboard module</p>
        <div class="card-block">
          <p>Dashboard</p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae iure nihil aliquid
            est! Eum ad autem dolorem obcaecati, itaque quibusdam ullam maiores laudantium provident
            mollitia velit? Culpa voluptas fuga voluptates!
          </p>
        </div>
      </div>
      <div class="col-6 q-pa-md full-height">
        <p class="card-title">&nbsp;</p>
        <div class="card-block">
          <p>Dashboard</p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae iure nihil aliquid
            est! Eum ad autem dolorem obcaecati, itaque quibusdam ullam maiores laudantium provident
            mollitia velit? Culpa voluptas fuga voluptates!
          </p>
        </div>
      </div>
    </div>

    <!-- <rich-text-editor/> -->
  </div>
</template>

<script>
// import richTextEditor from '@/components/editor/Editor.vue';

export default {
  // components: {
  //   'rich-text-editor': richTextEditor,
  // },
};

</script>
